import { CustomError } from '@devim-front/error';
import { RpcError } from 'services/RpcService/errors/RpcError';

/**
 * Представляет ошибку, обозначающую, что заём не найден
 */
export class NotFoundError extends CustomError {
  public constructor(innerError: RpcError) {
    super('NotFoundError', innerError.message);
  }
}
